import { SearchResultPrice } from '@/scopes/search/search/infrastructure/api/types'
import {
  AccommodationService,
} from '@/scopes/search/search/pages/SearchPage/components/Results/Result'

interface IncludedServicesTranslations {
  skiMaterial: string
  skiPass: string
  skiPassWithPrice: string
  skiPassWithSkiMaterial: string
  skiPassWithPriceAndSkiMaterial: string
}

export function getAccommodationServices(translations: IncludedServicesTranslations, price?: SearchResultPrice): AccommodationService[] {
  if (!price?.includedServices)
    return []

  const { includedServices, skiPassPublicPrice } = price
  const services: AccommodationService[] = []

  if ('carrental' in includedServices) {
    services.push({ key: 'carrental', icon: 'CarRight', text: includedServices.carrental || '' })
  }

  if ('transfer' in includedServices) {
    services.push({ key: 'transfer', icon: 'BusFront', text: includedServices.transfer || '' })
  }

  if ('skimaterial' in includedServices || 'skipass' in includedServices) {
    const hasSkiMaterial = 'skimaterial' in includedServices
    const hasSkiPass = 'skipass' in includedServices
    const hasSkiPassPrice = Boolean(skiPassPublicPrice)
    const text = !hasSkiPass
      ? translations.skiMaterial
      : hasSkiMaterial
        ? hasSkiPassPrice
          ? translations.skiPassWithPriceAndSkiMaterial
          : translations.skiPassWithSkiMaterial
        : hasSkiPassPrice
          ? translations.skiPassWithPrice
          : translations.skiPass

    services.push({ key: 'skipass', icon: 'SkiPass', text })
  }

  return services
}
